export function isCI() {
    if (isNode()) {
        return !!process.env.TEAMCITY_VERSION || !!process.env.BUILDKITE;
    }
    return false;
}
function isNode() {
    var _a;
    // todo: need to add a browser test
    return typeof process !== 'undefined' && ((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node) != null;
}
//# sourceMappingURL=utils.js.map